module.exports = __webpack_public_path__ + "img/затопленны осинник 70х90.7d62f273.jpg";